import * as React from "react";

interface Props {
  appId: number;
  docId: number;
  className?: string;
  children?: any;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const DocumentLink: React.FunctionComponent<Props> = ({
  appId,
  docId,
  className,
  children,
  onClick,
}): React.ReactElement => (
  <a
    target="_blank"
    rel="noopener noreferrer"
    href={`/underwriter/app/${appId}/documents/viewer/${docId}`}
    className={className}
    onClick={onClick}
  >
    {children || "View"}
  </a>
);

export default DocumentLink;
